import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-设备流量*/
import React from 'react';
import BossTable from "../../../Common/BossTable";
import { parse } from "../../../../utils/commonUtilFunc";
import { addComma } from "../../../../utils/commonUtilFunc";
import { withRouter } from "react-router-dom";
import UserAppRank from "./UserFlowRankSubs/UserAppRank";
import DayFlowChart from "./AppRankSubs/DayFlowChart";
import { connect } from "dva";
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var TabPane = _Tabs.TabPane;
var UserFlowRank = /*#__PURE__*/function (_React$Component) {
  _inherits(UserFlowRank, _React$Component);
  function UserFlowRank(props) {
    var _this;
    _classCallCheck(this, UserFlowRank);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserFlowRank).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseUserFlowDetailModal", function () {
      _this.setState({
        ifUserFlowDetailModalShow: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOpenUserFlowDetailModal", function (record) {
      _this.setState({
        ifUserFlowDetailModalShow: true,
        selectedUserIp: record.sip,
        selectedUserFlow: record.flow || 0
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_users_dpi", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_users_dpi",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn,
          top: _this.state.top,
          sip: _this.state.sip,
          companyid: _this.ifCompany ? _this.id : sessionStorage.getItem("companyId")
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      _this.setState({
        top: value || ""
      }, function () {
        _this.get_users_dpi();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      _this.setState({
        sip: e.target.value
      }, function () {
        if (_this.state.sip === "") {
          _this.get_users_dpi();
        }
      });
    });
    _this.state = {
      ifUserFlowDetailModalShow: false,
      selectedUserIp: "",
      selectedUserFlow: "0",
      top: "5",
      sip: ""
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    _this.id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(UserFlowRank, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_users_dpi();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var columns = [{
        title: "User IP Address",
        dataIndex: 'sip',
        key: 'ip',
        render: function render(text, record) {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              color: "#1890FF",
              cursor: "pointer"
            },
            onClick: function onClick() {
              return _this2.handleOpenUserFlowDetailModal(record);
            }
          }, record.sip);
        }
      }, {
        title: "MAC address",
        dataIndex: 'mac',
        key: 'cpde4'
      }, {
        title: "Traffic (MB)",
        dataIndex: 'flow',
        key: 'flow',
        render: function render(text) {
          return text ? (text / 1024 / 1024).toFixed(4) : "";
        }
      }, {
        title: "Proportion of traffic (%)",
        dataIndex: 'percent',
        key: 'percent',
        render: function render(text, record) {
          return (record.flow / 1024 / 1024 / _this2.props.flow * 100).toFixed(2);
        }
      }];
      var search = parse(this.props.location.search);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_users_dpi
      }, "search"), /*#__PURE__*/React.createElement(BossTable, {
        columns: columns,
        style: {
          marginTop: 16
        },
        dataSource: this.props.ci0303Info.userFlowRankTableDataSource
      }), /*#__PURE__*/React.createElement(_Modal, {
        title: "User traffic details",
        footer: null,
        visible: this.state.ifUserFlowDetailModalShow,
        width: 925,
        onCancel: this.handleCloseUserFlowDetailModal,
        destroyOnClose: true
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
        className: "title-device-name"
      }, "User IP Address", ":", this.state.selectedUserIp), /*#__PURE__*/React.createElement("div", {
        className: "title-device-info"
      }, /*#__PURE__*/React.createElement("span", null, "time slot", ":\xA0\xA0", search.start_tm, "\xA0", "to", "\xA0", search.end_tm), /*#__PURE__*/React.createElement("span", null, "Traffic type", ":\xA0\xA0", search.tunnel_dir), /*#__PURE__*/React.createElement("span", null, "Traffic size", ":\xA0", addComma((this.state.selectedUserFlow / 1024 / 1024).toFixed(2)), "\xA0\xA0MB"))), /*#__PURE__*/React.createElement(_Tabs, null, /*#__PURE__*/React.createElement(TabPane, {
        key: "1",
        tab: "Application ranking"
      }, /*#__PURE__*/React.createElement(UserAppRank, {
        selectedUserIp: this.state.selectedUserIp
      })), /*#__PURE__*/React.createElement(TabPane, {
        key: "2",
        tab: "Daily flow trend chart"
      }, /*#__PURE__*/React.createElement(DayFlowChart, {
        sip: this.state.selectedUserIp
      })))));
    }
  }]);
  return UserFlowRank;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(UserFlowRank)));